import { Result } from '@inrev/core';
import { parseFormulaTerms, FormulaParseError, formulaFromTerms } from './formula.mjs';

const CURRENT_POLICY = new Set([
    "dropped",
    "removed",
    "line",
]);
const REMOVED_OR_LINE_POLICY = new Set(["removed", "line"]);
const LINE_ONLY_POLICY = new Set(["line"]);
function balanceSheetSectionPolicy(path) {
    if (path.startsWith("assets.current.") || path.startsWith("liabilities.current.")) {
        return CURRENT_POLICY;
    }
    return REMOVED_OR_LINE_POLICY;
}
const kindLabel = (kind) => kind === "dropped" ? "d=" : kind === "removed" ? "r=" : "bare";
function normalizeFormulaForSection(raw, policy) {
    return parseFormulaTerms(raw).flatMap((terms) => {
        const disallowed = terms.find((term) => !policy.has(term.kind));
        if (disallowed) {
            const allowedLabels = [...policy].map(kindLabel).join(", ");
            return Result.err(new FormulaParseError("INVALID_SYNTAX", `Instruction ${kindLabel(disallowed.kind)} is not allowed here; allowed: ${allowedLabels}`));
        }
        return Result.ok(formulaFromTerms(terms));
    });
}

export { LINE_ONLY_POLICY, balanceSheetSectionPolicy, normalizeFormulaForSection };
